import baywash from "@/assets/clients/baywash-enterprises.webp";
import cocaColaAmatil from "@/assets/clients/coca-cola-amatil.webp";
import kellyPartners from "@/assets/clients/kelly-partners.webp";
import kn from "@/assets/clients/kn.webp";
import iconSeptech from "@/assets/clients/icon-septech.webp";
import mcdonalds from "@/assets/clients/mcdonalds.webp";
import mngd from "@/assets/clients/mngd.webp";
import redRooster from "@/assets/clients/red-rooster.webp";

import tonyFerguson from "@/assets/clients/tony-ferguson.webp";
import nrma from "@/assets/clients/nrma.webp";
import omg from "@/assets/clients/omg-co.webp";
import pilbara from "@/assets/clients/pilbara-resource-group.webp";

import resourcePartners from "@/assets/clients/resource-partners-australia.webp";
import tot from "@/assets/clients/tot-transport.webp";
import triniti from "@/assets/clients/triniti-health.webp";
import wesfarmers from "@/assets/clients/wesfarmers.webp";

/**
 * Single source for organisation names. One legal name per entry, used by both
 * ClientLogos and TrackRecord. Do not retype a name in a component.
 */
export type Client = {
  /** The legal name, as published. */
  name: string;
  /** Optional logo asset. Absent where no logo is published. */
  logo?: string;
  /** How Adam is connected to the organisation. */
  relationship: "client" | "employer";
  /** Industry label, used by TrackRecord. */
  industry?: string;
  /** The role Adam held, for career employers. */
  role?: string;
};

export const clients: Client[] = [
  { name: "Resource Partners Australia", logo: resourcePartners, relationship: "client", industry: "Recruitment Services" },
  { name: "Kelly+Partners Northern Beaches", logo: kellyPartners, relationship: "client", industry: "Professional Services" },
  { name: "Triniti Health Co", logo: triniti, relationship: "client", industry: "Healthcare" },
  { name: "MNGD", logo: mngd, relationship: "client", industry: "Workplace Technology" },
  { name: "Kenthurst Nursery", relationship: "client", industry: "Wholesale and Retail" },
  { name: "IMF Fit-outs", relationship: "client", industry: "Manufacturing and Construction" },
  { name: "OMG Signage", logo: omg, relationship: "client", industry: "Manufacturing and Construction" },
  { name: "Pilbara Resource Group", logo: pilbara, relationship: "client", industry: "Mining" },
  
  { name: "Baywash Enterprises", logo: baywash, relationship: "client", industry: "Commercial Services" },
  { name: "KN", logo: kn, relationship: "client", industry: "Logistics" },
  { name: "Coca-Cola Amatil", logo: cocaColaAmatil, relationship: "employer", industry: "FMCG and Manufacturing", role: "Assistant Commercial Manager, National Pricing" },
  { name: "Kmart (Wesfarmers)", logo: wesfarmers, relationship: "employer", industry: "Retail", role: "National Commercial Manager" },
  { name: "TOT Group", logo: tot, relationship: "employer", industry: "Transport and Electrical", role: "General Manager" },
  { name: "NRMA (Roadside Assistance)", logo: nrma, relationship: "employer", industry: "Roadside Services", role: "Roadside Relaunch Project" },
  { name: "Icon Septech", logo: iconSeptech, relationship: "employer", industry: "Water Infrastructure", role: "Junior Accountant" },
  { name: "Tony Ferguson", logo: tonyFerguson, relationship: "employer", industry: "Health and Wellness", role: "National Stock Controller" },
  { name: "Red Rooster", logo: redRooster, relationship: "employer", industry: "Quick Service Restaurants", role: "Store Manager and Systems Implementation Manager" },
  { name: "McDonald's", logo: mcdonalds, relationship: "employer", industry: "Quick Service Restaurants", role: "Crew Leader and Chef of the Year" },
  { name: "The Coffee Club", relationship: "employer", industry: "Quick Service Restaurants", role: "Kitchen Leader" },
];

export const clientEngagements = clients.filter((c) => c.relationship === "client");
export const careerEmployers = clients.filter((c) => c.relationship === "employer");

/** Entries that carry a logo asset, for the logo rows. */
export const withLogo = (list: Client[]) =>
  list.filter((c): c is Client & { logo: string } => Boolean(c.logo));
